'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

const React = require('react');
const React__default = _interopDefault(React);
const tslib = require('tslib');
const PresenceContext = require('../../context/PresenceContext.js');
const usePresence = require('../../components/AnimatePresence/use-presence.js');
const types = require('../../render/utils/types.js');
const makeRenderlessComponent = require('../utils/make-renderless-component.js');
const shouldInheritVariant = require('../utils/should-inherit-variant.js');

/**
 * TODO: This component is quite small and no longer directly imports animation code.
 * It could be a candidate for folding back into the main `motion` component.
 */
var ExitComponent = makeRenderlessComponent.makeRenderlessComponent(function (props) {
  var custom = props.custom,
    visualElement = props.visualElement;
  var _a = tslib.__read(usePresence.usePresence(), 2),
    isPresent = _a[0],
    onExitComplete = _a[1];
  var presenceContext = React.useContext(PresenceContext.PresenceContext);
  React.useEffect(function () {
    var _a, _b;
    var animation = (_a = visualElement.animationState) === null || _a === void 0 ? void 0 : _a.setActive(types.AnimationType.Exit, !isPresent, {
      custom: (_b = presenceContext === null || presenceContext === void 0 ? void 0 : presenceContext.custom) !== null && _b !== void 0 ? _b : custom
    });
    !isPresent && (animation === null || animation === void 0 ? void 0 : animation.then(onExitComplete));
  }, [isPresent]);
});
/**
 * @public
 */
var Exit = {
  key: "exit",
  shouldRender: function (props) {
    return !!props.exit && !shouldInheritVariant.checkShouldInheritVariant(props);
  },
  getComponent: function () {
    return ExitComponent;
  }
};

exports.Exit = Exit;
